module.exports = __webpack_public_path__ + "static/media/chess-knight-alt-light.bb64c5a5.svg";